import type { HelpFile } from '../../types/help'
import { ThemeToggleTestIds } from '../../../testids/ThemeToggleTestIds'

// Top-bar single-purpose icon — its aria-label already describes the action.
export const themeToggleHelp: HelpFile = {
  texts: {
    [ThemeToggleTestIds.btnThemeToggle]: null,
  },
}
